<template>
  <div class="popup-overlay">
    <div class="error-popup">
        <div class="error-popup__icon">
            <img src="../../../assets/img/information-icon.svg"/>
        </div>
        <div class="error-popup__content">
            <strong>{{value}}</strong>
        </div>
        <a class="error-popup__return-button" @click="onClickPopup">Tamam</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Popup",
  props:{
    value:{
      type: String,
      required: true
    }
  },
  components: {
  },
  mounted(){
    //console.log("Popup-Mounted")
  },
  data: () => ({
    showPopup:false
  }),
  methods:{
    onClickPopup(){
      //console.log("onClickPopup")
      /*this.showPopup=false*/
      this.$emit('cancel');
    }
  }
};
</script>